import React from 'react';
import { Link } from 'react-router'
import $ from 'jquery'

let config = require('config');

class Topics extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      isMobile:false
    }
    this.mouseEnter = this.mouseEnter.bind(this)
    this.mouseLeave = this.mouseLeave.bind(this)
  }

  componentDidMount() {
    const { actions } = this.props;
    actions.getTopics()

    $(window).on("resize", this.resize.bind(this))
    this.resize()
  }

  componentWillUnmount() {
    $(window).off("resize")
  }

  mouseEnter(e) {
    var target = $(e.currentTarget)
    target.closest(".topics_list__block").find(".right__thumbnail a").addClass("hover")
  }

  mouseLeave(e) {
    var target = $(e.currentTarget)
    target.closest(".topics_list__block").find(".right__thumbnail a").removeClass("hover")
  }

  render() {
    const { actions, data } = this.props;
    var self = this
    var topics = data.topics;
    document.title = "TOPICS | " + config.default.SITE_NAME
    return (
      <div id="topics" className="main">
        <div className="topics_inner">
          { topics ?
              <div className="topics_list">
                { topics.contents.map(function(topic, i) {
                  return (
                    <div key={i} className="topics_list__block">
                      <div className="block__right">
                        <div className="right__thumbnail">
                          <Link className="filter" to={"/topics/" + topic.id + "/"}>
                            <img src={topic.image.url} />
                          </Link>
                        </div>
                      </div>
                      <div className="block__left">
                        <Link onMouseEnter={self.mouseEnter} onMouseLeave={self.mouseLeave} to={"/topics/" + topic.id + "/"}>
                          <div className="left__date">{topic.date}</div>
                          <div className="left__title">{topic.title}</div>
                        </Link>
                      </div>
                    </div>
                  )
                })}
              </div>
            :null
          }
        </div>
      </div>
    );
  }

  resize() {
    var w = $(window).width()
    var h = $(window).height()
    if (w < config.default.MEDIA_ALL_MOBILE) {
      if (!this.state.isMobile) {
        this.setState({ isMobile:true });
      }
    } else {
      if (this.state.isMobile) {
        this.setState({ isMobile:false });
      }
    }
  }

}

Topics.displayName = 'Topics';
Topics.propTypes = {};
Topics.defaultProps = {};

export default Topics;



// WEBPACK FOOTER //
// ./components/Topics.js